"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWorkingCanvas = void 0;
var createWorkingCanvas = exports.createWorkingCanvas = function createWorkingCanvas(sourceObject) {
  var copy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var width = sourceObject.width,
    height = sourceObject.height;
  var canvas = Object.assign(document.createElement("canvas"), {
    width: width,
    height: height
  });
  var ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Could not get 2d context for working canvas!");
  }
  if (copy) {
    ctx.drawImage(sourceObject, 0, 0);
  }
  return [canvas, ctx];
};